'use client'

import { noop } from 'lodash'
import { createContext, Dispatch, SetStateAction } from 'react'

import { UiState } from '@marketplace-web/shared/ui-state-util'
import { ConversationListItemType } from '@marketplace-web/messaging/conversation-messaging-data'

import { DEFAULT_PAGE_NUMBER, DEFAULT_PER_PAGE } from '../../constants'

type UpdateConversationTitleArgs = {
  id: string | number
  title: string
  updated_at?: string
}

type ConversationListMethodArgs = {
  id: string | number
  title?: string
}

export type ConversationListContextType = {
  uiState: UiState
  controlConversations: Array<ConversationListItemType>
  conversations: Array<ConversationListItemType>
  isEndReached: boolean
  perPage: number
  currentPage: number
  websocketUserId?: string
  setCurrentPage: Dispatch<SetStateAction<number>>
  updateListConversationTitle: (args: UpdateConversationTitleArgs) => void
  updateConversation: (args: ConversationListMethodArgs) => void
  markAsRead: (args: ConversationListMethodArgs) => void
}

const ConversationListContext = createContext<ConversationListContextType>({
  uiState: UiState.Idle,
  controlConversations: [],
  conversations: [],
  isEndReached: false,
  perPage: DEFAULT_PER_PAGE,
  currentPage: DEFAULT_PAGE_NUMBER,
  updateListConversationTitle: noop,
  updateConversation: noop,
  markAsRead: noop,
  setCurrentPage: noop,
})

export default ConversationListContext
